import './../../../../components/search-form/search-form_custom/search-form_custom';
import './../../../../components/tour-type/tour-type_custom/tour-type_custom';
import './../../../../components/search-tour/search-tour_custom/search-tour_custom';
import './../../../../components/tour-period/tour-period_custom/tour-period_custom';
import './../../../../components/form-package/form-package_custom/form-package_custom';
import './../../../../components/popup/popup_popup-acf/popup_popup-acf';



// WEBPACK FOOTER //
// ./resources/templates/changply/assets/js/_import-components.js